import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { FormData } from 'components/misc'
import { Title } from 'components/layout'
import { Image } from 'containers/misc'

export default class TasksAssessorReport extends Component {
  static propTypes = {
    assessorReport: PropTypes.object,
    assessorPhotos: PropTypes.any,
    assessed: PropTypes.bool
  }

  render() {
    const { assessorReport, assessorPhotos, assessed } = this.props

    return (
      <div>
        {assessorReport &&
          <div>
            <h2>
              {get(assessorReport, 'title')}
              .
              {' '}
              {get(assessorReport, 'firstName')}
              {' '}
              {get(assessorReport, 'lastName')}
            </h2>
            <div className="row">
              <div className="col-xs-6">
                <FormData label="Email" intlKey="label.email">
                  {get(assessorReport, 'email')}
                </FormData>
              </div>
              <div className="col-xs-6">
                <FormData label="Phone" intlKey="label.phone">
                  {get(assessorReport, 'phone')}
                </FormData>
              </div>
              <div className="col-xs-12">
                <FormData label="Report" intlKey="label.report">
                  {get(assessorReport, 'assessorReport')}
                </FormData>
              </div>
              <div className="col-xs-6">
                <FormData label="Qualification" intlKey="label.qualifications">
                  {get(assessorReport, 'myQualification')}
                </FormData>
              </div>
              <div className="col-xs-6">
                <FormData label="Experience" intlKey="label.experience">
                  {get(assessorReport, 'myExperience')}
                </FormData>
              </div>
            </div>
          </div>}
        {!assessorReport &&
          assessed &&
          <div>
            <Title h2 intlKey="moduleTitle.assessor_report">
              Assessor report
            </Title>
            {assessorPhotos
              ? <Image src={assessorPhotos} />
              : <FormattedMessage
                  id="label.no_data"
                  defaultMessage="No data"
                />}
          </div>}
      </div>
    )
  }
}
